import api from "../lib/api";

export interface FullDetailsQAItem {
    qa_id: number;
    question: string;
    answer: string;
}

export type FullDetailsResponse = {
    saved_grant: {
        id: number;
        grant_title: string;
        status: string;
        updated_at: string;
        grant?: string | number;
        grant_id?: string | number;
        url?:string;
    };
    draft: any;
    qa_list: {
  map(arg0: (qa: any) => { qa_id: any; question: any; answer: any; status: "idle" | "saving" | "saved" | "error"; word_limit: any; }): { qa_id: number | null; question: string; answer: string; status: "idle" | "saving" | "saved" | "error"; word_limit: number; }[];
  id: number;
  question: string;
  answer: string;
  word_limit: number | null;
}

};

export async function getGrantFullDetails(
    savedGrantId: number
): Promise<FullDetailsResponse> {
    const res = await api.get("/grant-writing/qa/full-details/", {
        params: { saved_grant_id: savedGrantId },
    });
    return res.data;
}

/* ---------- Manual save (user-written answer) ---------- */

export interface ManualQARequest {
    saved_grant_id: number;
    question: string;
    answer: string;
}

export interface ManualQAResponse {
    qa_id: number;
    question: string;
    answer: string;
}

/**
 * POST /grant-writing/qa/manual-qa/
 * Body: { saved_grant_id, question, answer }
 */
export async function saveManualQA(
    payload: ManualQARequest
): Promise<ManualQAResponse> {
    const res = await api.post("/grant-writing/qa/manual-qa/", payload);
    return res.data;
}

/* ---------- AI suggest ---------- */

export interface AskAIRequest {
    saved_grant_id: number;
    question: string;
    use_ai?: boolean;
    word_limit_by_ai?: number| null;
}

export interface AskAIResponse {
    qa_id: number;
    question: string;
    answer: string;
}

/**
 * POST /grant-writing/qa/ask/
 * Body: { saved_grant_id, question, use_ai: true }
 */
export async function askAIForQA(
    payload: AskAIRequest
): Promise<AskAIResponse> {
    const res = await api.post("/grant-writing/qa/ask/", payload);
    return res.data;
}

export async function updateQA(qa_id: number, payload: { question: string; answer: string }) {
    const res = await api.patch(`/grant-writing/qa/${qa_id}/update/`, {
        question: payload.question,
        answer: payload.answer,
    });
    return res.data;
}

/* ---------- Delete QA ---------- */
/**
 * DELETE /grant-writing/qa/{id}/delete/
 * returns 204 on success
 */
export async function deleteQA(qa_id: number) {
    const res = await api.delete(`/grant-writing/qa/${qa_id}/delete/`);
    return res.data;
}

/* ---------- Export PDF ---------- */
/**
 * GET /grant-writing/drafts/{id}/export-pdf/
 * returns a PDF file (binary)
 */
export async function exportFullPdf(
    savedGrantId: number
): Promise<Blob> {
    const res = await api.get("/grant-writing/qa/export-full-pdf/", {
        params: { saved_grant_id: savedGrantId },
        responseType: "blob",
    });
    return res.data;
}